import { useEffect, useState } from 'react'

import { Button } from 'src/shared/components/ui/buttons/button'
import DashboardModal from 'src/shared/components/ui/dashboard/dashboard-modal'

import BusinessInfoInputField from '../components/business-info-input-field'
import { BusinessInfoLabels } from '../schemas/business-create'
import type { BusinessInfo } from '../schemas/business-create'

type EditInfoModalProps = {
  open: boolean
  onClose: () => void
  infoField: keyof BusinessInfo | null
  initialValue: any | null
  onSave: (value: any) => void
}

const EditInfoModal = ({ open, onClose, infoField, initialValue, onSave }: EditInfoModalProps) => {
  const [value, setValue] = useState<any>(initialValue)

  const _onSave = (value: any) => {
    onSave(value)
    _onClose()
  }

  const _onClose = () => {
    setValue(initialValue)
    onClose()
  }

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue, infoField])

  if (!infoField) return null

  return (
    <DashboardModal open={open} onClose={_onClose}>
      <div className="relative z-[100] flex h-auto max-h-[80vh] w-fit min-w-[400px] flex-col items-center justify-between gap-4 rounded-[25px] bg-white">
        <div className="flex w-full flex-col items-center justify-start gap-5 px-5 pt-10">
          <h2 className="text-[32px] font-semibold leading-tight text-primary">{BusinessInfoLabels[infoField]}</h2>
          <div className="w-full py-8">
            <BusinessInfoInputField infoField={infoField} value={value} onChange={setValue} />
          </div>
        </div>
        <div className="flex w-full flex-row items-center justify-end border-t border-lightBorder p-4">
          <Button variant="default" size="xl" onClick={() => _onSave(value)} className="rounded-full">
            Save changes
          </Button>
        </div>
      </div>
    </DashboardModal>
  )
}

export default EditInfoModal
